import { createFileRoute } from '@tanstack/react-router'

import { ProductGuaranteesPage } from '../../../../../../components/pages/product-guarantees-page.tsx'
import { PermissionChecker } from '../../../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/(customer)/_portal/product-guarantees/$subscriptionId/$productName')({
  component: () => (
    <PermissionChecker requiredPermissions={['contract.read']}>
      <ProductGuaranteesPage />
    </PermissionChecker>
  ),
})
